module.exports = __webpack_public_path__ + "img/comparison3.2e9be843.png";